import { render, staticRenderFns } from "./left-arrow.vue?vue&type=template&id=3e333019&scoped=true"
import script from "./left-arrow.vue?vue&type=script&lang=js"
export * from "./left-arrow.vue?vue&type=script&lang=js"
import style0 from "./left-arrow.vue?vue&type=style&index=0&id=3e333019&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e333019",
  null
  
)

export default component.exports